import { useClientServices } from '@audacy-clients/core/utils/clientServices';
import type { IViewContext } from '@audacy-clients/core/utils/viewContext';

export const useScreenView = (): (({ viewContext }: { viewContext?: IViewContext }) => void) => {
  const { clientServices } = useClientServices();

  const onScreenView = ({ viewContext }: { viewContext?: IViewContext }): void => {
    if (viewContext) {
      clientServices.getAnalyticServices().sendScreenView(viewContext);
    }
  };

  return onScreenView;
};
